import { env } from '@/config/env';
import { WEBSITE_ROUTES } from '@/constants/routes';

export const WEBSITE_PRODUCT_URL = `${env.WEBSITE_URL}${WEBSITE_ROUTES.PRODUCT}`;
export const HIDDEN_CATEGORY_MESSAGE =
  'Ця категорія прихована адміністратором сайту. Ви зможете опублікувати товар, як тільки категорія буде доступна.';
export const CANNOT_PUBLISH_WITHOUT_PRICE_CODE = 'cannot_publish_product_without_price';
